import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import MarqueeStrip from "../components/MarqueeStrip";
import About from "../components/About";
import Products from "../components/Products";
import Process from "../components/Process";
import Quality from "../components/Quality";
import Export from "../components/Export";
import VideoSection from "../components/VideoSection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import BackToTop from "../components/BackToTop";
import { useReveal } from "../hooks/useReveal";
import { useLenis } from "../hooks/useLenis";
import useSEO from "../hooks/useSEO";
import { useLang } from "../contexts/LanguageContext";

const META = {
  en: {
    title: "EKOBIOTEK — Sunflower & Vegetable Oil Producer | Kherson, Ukraine",
    description:
      "EKOBIOTEK-UKRAINA, LLC — Ukrainian producer of refined and crude sunflower oil since 2003. Export-grade quality, ISO 22000, HACCP, Non-GMO. Flexitank, bottles, drums.",
  },
  fr: {
    title: "EKOBIOTEK — Producteur d'huile de tournesol & d'huile végétale | Kherson, Ukraine",
    description:
      "EKOBIOTEK-UKRAINA SARL — Producteur ukrainien d'huile de tournesol raffinée et brute depuis 2003. Qualité export, ISO 22000, HACCP, Non-OGM. Flexitank, bouteilles, fûts.",
  },
  ua: {
    title: "EKOBIOTEK — виробник соняшникової та рослинної олії | Херсон, Україна",
    description:
      "ТОВ ЕКОБИОТЕК-УКРАЇНА — український виробник рафінованої та сирої соняшникової олії з 2003 року. Експортна якість, ISO 22000, HACCP, Non-GMO.",
  },
};

const Home = () => {
  const ref = useReveal();
  useLenis();
  const { lang } = useLang();
  const meta = META[lang] || META.en;
  useSEO({
    title: meta.title,
    description: meta.description,
    canonical: "https://ekobiotek-ukraine.com.ua/",
    ogImage: "https://ekobiotek-ukraine.com.ua/ekobiotek-logo.jpg",
  });

  return (
    <div ref={ref} data-testid="home-page" className="relative">
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <VideoSection />
        <MarqueeStrip />
        <About />
        <Products />
        <Process />
        <Quality />
        <Export />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Home;
